import { useInfiniteQuery } from '@tanstack/react-query';
import isNil from 'lodash-es/isNil';
import { useEffect, useMemo } from 'react';
import { getPageQueryParams } from './pagination';
const NUMBER_PER_PAGE = 100;
export function useLazyQuery({ isEnabled, queryParams, fetcher, autoFetchNextPage = true }) {
    const getRequester = (paginationParams) => fetcher({
        ...(queryParams ?? {}),
        limit: NUMBER_PER_PAGE,
        ...(paginationParams ?? {})
    });
    const { refetch, data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isFetching } = useInfiniteQuery({
        queryKey: getRequester().key,
        queryFn: ({ pageParam }) => getRequester(pageParam).request(),
        enabled: isEnabled,
        getNextPageParam: (lastPage, allPages) => {
            return !isNil(lastPage?.next)
                ? {
                    ...queryParams,
                    ...getPageQueryParams(allPages.length, NUMBER_PER_PAGE)
                }
                : undefined;
        },
        initialPageParam: {}
    });
    useEffect(() => {
        if (autoFetchNextPage && !isLoading && !isFetching && !isFetchingNextPage && hasNextPage) {
            fetchNextPage();
        }
    }, [fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isFetching, autoFetchNextPage]);
    return useMemo(() => {
        const concatenedData = data?.pages.reduce((acc, d) => acc.concat(d?.results ?? []), []) ?? [];
        return {
            data: concatenedData,
            isLoading,
            rawData: data,
            fetchNextPage,
            hasNextPage,
            isFetchingNextPage,
            refetch
        };
    }, [data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, refetch]);
}
